<template>
  <div class="report_page">
    <v-card flat="flat" class="nuclear">
      <v-card-title class="nuclear-title">Report</v-card-title>
      <v-card-text class="parent">
        <div class="report_summary">
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-row class="vendor_part">
                <v-col cols="12" sm="9" md="12">
                  <v-card class="child1">
                    <v-card-title>{{ filename }}</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="2" class="item">
                          <p class="pointer">Critical</p>
                          <p class="critical">{{ criticalCount }}</p>
                        </v-col>
                        <v-col cols="12" sm="2" class="item">
                          <p class="pointer">High</p>
                          <p class="high">{{ highCount }}</p>
                        </v-col>
                        <v-col cols="12" sm="2" class="item">
                          <p class="pointer">Medium</p>
                          <p class="medium">{{ mediumCount }}</p>
                        </v-col>
                        <v-col cols="12" sm="2" class="item">
                          <p class="pointer">Low</p>
                          <p class="low">{{ lowCount }}</p>
                        </v-col>
                        <v-col cols="12" sm="2" class="item">
                          <p class="pointer">Ignore</p>
                          <p class="infor">{{ ignoreCount }}</p>
                        </v-col>
                        <v-col cols="12" sm="2" class="item">
                          <p class="pointer">Total</p>
                          <p class="total">{{ total }}</p>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="3" md="12">
                  <v-btn class="download" @click="downloadReport">DOWNLOAD REPORT</v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="6" class="summary">
              <v-card class="child2">
                <v-card-title>Summary</v-card-title>
                <v-card-text>
                  <p>
                    A total of ( {{ total }} ) findings were discovered, ({{
                      criticalCount
                    }}) of which are rated critical in nature. Critical security
                    issues provide an exposure which could be easily exploited
                    and typically provides an unauthorized entity remote access
                    to the Building Automation System. Whitescope suggests
                    critical issues be addressed immediately, as they present
                    the highest risks from a security standpoint. In addition to
                    the critical risk vulnerabilities, the BASEC client also
                    identified several other security issues which should be
                    addressed. The details associated with these findings are
                    provided in the report below.
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <p>{{ this.errorMessage }}</p>
        <v-data-table
          :headers="headers"
          :items="items"
          :hide-default-footer="true"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :disable-pagination="true"
          item-key="id"
          show-expand
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row class="not_mobile">
                <v-col cols="12" sm="4" md="2" lg="2">
                  <div class="action">
                    <v-autocomplete
                      v-model="item.severity"
                      :rules="fieldRules"
                      :items="severities"
                      item-text="name"
                      required
                      @change="changeSeverity(item)"
                    ></v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="2" lg="1">
                  <div
                    class="action"
                    v-if="item.ignore == false"
                    @click="updateFinding(item)"
                  >
                    <font-awesome-icon class="share" icon="share" />
                    <p>Ignore</p>
                  </div>
                  <div
                    class="action"
                    v-if="item.ignore == true"
                    @click="updateFinding(item)"
                  >
                    <font-awesome-icon class="share" icon="share" />
                    <p>Include</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="2" lg="1">
                  <v-dialog v-model="deletedialog" persistent max-width="320">
                    <template v-slot:activator="{ on }">
                      <div class="action" v-on="on">
                        <font-awesome-icon class="delete" icon="trash-alt" />
                        <p>Delete</p>
                      </div>
                    </template>
                    <v-card class="modal">
                      <v-card-title>
                        <font-awesome-icon
                          class="delete_header"
                          icon="info-circle"
                        />
                        <p>Finding Delete Confirmation</p>
                      </v-card-title>
                      <v-card-text
                        >Are you sure you want to
                        <span class="bold">delete</span> this finding
                        <span class="bold">forever</span>?</v-card-text
                      >
                      <v-card-actions>
                        <v-btn small class="delete" @click="deleteFinding(item)"
                          >Yes</v-btn
                        >
                        <v-btn
                          small
                          class="cancel"
                          @click="deletedialog = false"
                          >No</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row class="mobile">
                <div class="action">
                  <v-autocomplete
                    v-model="item.severity"
                    :rules="fieldRules"
                    :items="severities"
                    required
                  ></v-autocomplete>
                </div>
                <div
                  class="action"
                  v-if="item.ignore == false"
                  @click="updateFinding(item)"
                >
                  <font-awesome-icon class="share" icon="share" />
                  <p>Ignore</p>
                </div>
                <div
                  class="action"
                  v-if="item.ignore == true"
                  @click="updateFinding(item)"
                >
                  <font-awesome-icon class="share" icon="share" />
                  <p>Include</p>
                </div>
                <v-dialog
                  v-model="deletedialog_mobile"
                  persistent
                  max-width="320"
                >
                  <template v-slot:activator="{ on }">
                    <div class="action" v-on="on">
                      <font-awesome-icon class="delete" icon="trash-alt" />
                      <p>Delete</p>
                    </div>
                  </template>
                  <v-card class="modal">
                    <v-card-title>
                      <font-awesome-icon
                        class="delete_header"
                        icon="info-circle"
                      />
                      <p>Finding Delete Confirmation</p>
                    </v-card-title>
                    <v-card-text
                      >Are you sure you want to
                      <span class="bold">delete</span> this finding
                      <span class="bold">forever</span>?</v-card-text
                    >
                    <v-card-actions>
                      <v-btn small class="delete" @click="deleteFinding(item)"
                        >Yes</v-btn
                      >
                      <v-btn
                        small
                        class="cancel"
                        @click="deletedialog_mobile = false"
                        >No</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </td>
          </template>
          <template v-slot:item.severity="{ item }">
            <div class="not_mobile">
              <div class="severity_item" v-if="item.severity == 1">
                <font-awesome-icon class="critical" icon="circle" />
                <p>Critical</p>
              </div>
              <div class="severity_item" v-if="item.severity == 2">
                <font-awesome-icon class="high" icon="circle" />
                <p>High</p>
              </div>
              <div class="severity_item" v-if="item.severity == 3">
                <font-awesome-icon class="medium" icon="circle" />
                <p>Medium</p>
              </div>
              <div class="severity_item" v-if="item.severity == 4">
                <font-awesome-icon class="low" icon="circle" />
                <p>Low</p>
              </div>
            </div>
            <div class="mobile">
              <div>{{ item.name }}</div>
            </div>
          </template>
          <template v-slot:item.name="{ item }">
            <div class="not_mobile">
              <div>{{ item.name }}</div>
            </div>
            <div class="mobile">
              <div class="severity_item" v-if="item.severity == 1">
                <font-awesome-icon class="critical" icon="circle" />
                <p>Critical</p>
              </div>
              <div class="severity_item" v-if="item.severity == 2">
                <font-awesome-icon class="high" icon="circle" />
                <p>High</p>
              </div>
              <div class="severity_item" v-if="item.severity == 3">
                <font-awesome-icon class="medium" icon="circle" />
                <p>Medium</p>
              </div>
              <div class="severity_item" v-if="item.severity == 4">
                <font-awesome-icon class="low" icon="circle" />
                <p>Low</p>
              </div>
              <font-awesome-icon
                class="action_btn"
                icon="ellipsis-h"
                @click="expandMobileRow"
              />
            </div>
          </template>
          <template v-slot:item.action>
            <font-awesome-icon
              class="action_btn"
              icon="ellipsis-h"
              @click="expandRow"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        { text: "SEVERITY", align: "left", sortable: false, value: "severity" },
        { text: "NAME", align: "left", sortable: false, value: "name" },
        {
          text: "Description",
          align: "left",
          sortable: false,
          value: "description"
        },
        { text: "ACTION", align: "right", sortable: false, value: "action" }
      ],
      singleExpand: true,
      expanded: [],
      severities: [
        { value: 1, name: "Critical" },
        { value: 2, name: "High" },
        { value: 3, name: "Medium" },
        { value: 4, name: "Low" }
      ],
      fieldRules: [v => !!v || "Required"],
      ignoreshow: true,
      includeshow: false,
      deletedialog: false,
      deletedialog_mobile: false,
      errorMessage: ""
    };
  },
  props: ["id"],
  mounted() {
    let analysisID = this.$route.params.id;
    this.$store
      .dispatch("getReport", {
        id: this.id
      })
      .then(response => {})
      .catch(error => {
        this.errorMessage = error.response.data.message;
      });
  },
  computed: {
    filename() {
      return this.$store.state.analysis.reportname;
    },
    items() {
      return this.$store.state.analysis.total_report;
    },
    criticalCount() {
      return this.$store.getters.criticalCount;
    },
    highCount() {
      return this.$store.getters.highCount;
    },
    mediumCount() {
      return this.$store.getters.mediumCount;
    },
    lowCount() {
      return this.$store.getters.lowCount;
    },
    total() {
      return this.$store.getters.totalCount;
      return total;
    },
    ignoreCount() {
      return this.$store.getters.ignoreCount;
    }
  },
  methods: {
    expandRow(event) {
      let parent_row =
        event.target.tagName == "svg"
          ? event.target.parentElement.parentElement
          : event.target.parentElement.parentElement.parentElement;
      parent_row.firstElementChild.firstElementChild.click();
    },
    expandMobileRow(event) {
      let parent_row =
        event.target.tagName == "svg"
          ? event.target.parentElement.parentElement.parentElement.parentElement
              .parentElement
          : event.target.parentElement.parentElement.parentElement.parentElement
              .parentElement.parentElement;
      parent_row.firstElementChild.firstElementChild.lastElementChild.firstElementChild.click();
    },
    changeSeverity(item) {
      const data = {
        id: item.id,
        risk: item.severity
      };
      this.$store.dispatch("updateDetailFinding", data).then(response => {
        this.$store.dispatch("getReport", {
          id: this.$route.params.id
        });
      });
    },
    updateFinding(item) {
      item.ignore = !item.ignore;
      let findingId = item.id;
      this.$store
        .dispatch("updateDetailFinding", {
          id: findingId,
          ignore: item.ignore
        })
        .then(response => {
          let analysisID = this.$route.params.id;
          this.$store.dispatch("getReport", {
            id: analysisID
          });
        });
    },
    deleteFinding(item) {
      let findingId = item.id;
      this.$store
        .dispatch("deleteDetailFinding", {
          id: findingId
        })
        .then(response => {
          this.deletedialog = false;
          let analysisID = this.$route.params.id;
          this.$store.dispatch("getReport", {
            id: analysisID
          });
        });
    },
    downloadReport() {
      const data = {
        id: this.$route.params.id
      };
      this.$store.dispatch("downloadReport", data).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'report.pdf');
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
      });
    }
  }
};
</script>
